// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles common to components like ComputingScience.css, Mathematics.css, JuniorCore.css, Arts_requirements.css */

.requirement {
    margin-bottom: 30px;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.requirement h3 {
    color: #2c3e50;
    margin-bottom: 10px;
}

.requirement p {
    margin-bottom: 10px;
    color: #34495e;
}

.category {
    margin-left: 20px;
    margin-bottom: 10px;
}

.category h4 {
    font-size: 16px;
    color: #2980b9;
    margin-bottom: 5px;
}

.category p {
    font-size: 14px;
    margin-left: 10px;
    color: #555;
}

.course-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.course-tag {
    display: inline-flex;
    align-items: center;
    background-color: #e0e0e0;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 0.9em;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: background-color 0.2s ease;
}

.course-tag:hover {
    background-color: #d1d1d1;
}

.course-tag button {
    background: none;
    border: none;
    color: #888;
    cursor: pointer;
    font-size: 1.1em;
    margin-left: 8px;
    padding: 0;
}

.course-tag button:hover {
    color: #333;
}

.rest-section {
    margin-top: 20px;
}

.junior-core-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/simulator/faculty_of_science/general/junior_requirements.css"],"names":[],"mappings":"AAAA,kHAAkH;;AAElH;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb","sourcesContent":["/* Styles common to components like ComputingScience.css, Mathematics.css, JuniorCore.css, Arts_requirements.css */\n\n.requirement {\n    margin-bottom: 30px;\n    background-color: #f9f9f9;\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.requirement h3 {\n    color: #2c3e50;\n    margin-bottom: 10px;\n}\n\n.requirement p {\n    margin-bottom: 10px;\n    color: #34495e;\n}\n\n.category {\n    margin-left: 20px;\n    margin-bottom: 10px;\n}\n\n.category h4 {\n    font-size: 16px;\n    color: #2980b9;\n    margin-bottom: 5px;\n}\n\n.category p {\n    font-size: 14px;\n    margin-left: 10px;\n    color: #555;\n}\n\n.course-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.course-tag {\n    display: inline-flex;\n    align-items: center;\n    background-color: #e0e0e0;\n    border-radius: 4px;\n    padding: 6px 12px;\n    font-size: 0.9em;\n    max-width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    transition: background-color 0.2s ease;\n}\n\n.course-tag:hover {\n    background-color: #d1d1d1;\n}\n\n.course-tag button {\n    background: none;\n    border: none;\n    color: #888;\n    cursor: pointer;\n    font-size: 1.1em;\n    margin-left: 8px;\n    padding: 0;\n}\n\n.course-tag button:hover {\n    color: #333;\n}\n\n.rest-section {\n    margin-top: 20px;\n}\n\n.junior-core-categories {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
